/*
 * This is the default beefree template
 * It is loaded into the store when we need a default
 */
const blankBeeFree = {
    page: {
        body: {
            container: {
                style: {
                    "background-color": "#FFFFFF",
                },
            },
            content: {
                computedStyle: {
                    linkColor: "#0068A5",
                    messageBackgroundColor: "transparent",
                    messageWidth: "500px",
                },
                style: {
                    color: "#000000",
                    "font-family": "Arial, 'Helvetica Neue', Helvetica, sans-serif",
                },
            },
            type: "mailup-bee-page-proprerties",
        },
        description: "Template for BEE - Empty",
        rows: [
            {
                columns: [
                    {
                        "grid-columns": 12,
                        modules: [
                            {
                                descriptor: {},
                                type: "mailup-bee-newsletter-modules-empty",
                            },
                        ],
                        style: {
                            "background-color": "transparent",
                            "border-bottom": "0px dotted transparent",
                            "border-left": "0px dotted transparent",
                            "border-right": "0px dotted transparent",
                            "border-top": "0px dotted transparent",
                            "padding-bottom": "5px",
                            "padding-left": "0px",
                            "padding-right": "0px",
                            "padding-top": "5px",
                        },
                    },
                ],
                container: {
                    style: {
                        "background-color": "transparent",
                    },
                },
                content: {
                    style: {
                        "background-color": "transparent",
                        color: "#000000",
                        width: "500px",
                    },
                },
                type: "one-column-empty",
            },
        ],
        template: {
            name: "template-base",
            type: "basic",
            version: "0.0.1",
        },
        title: "Empty Bee Template",
    },
}
export default blankBeeFree
